import React from 'react';
import { ModalContainer } from 'shared/modals';

export function KioskScrollableModalContainer(props: React.ComponentProps<typeof ModalContainer>): JSX.Element {
  return <ModalContainer {...props} onAfterOpen={() => undefined} />;
}
